import getRecaptureEnabled from '@api/getRecaptureEnabled';
import { useQuery } from 'react-query';
const useGetRecaptureEnabled = (enabled = true) => {
    return useQuery('recapture', getRecaptureEnabled, {
        staleTime: Infinity,
        enabled,
    });
};
export default useGetRecaptureEnabled;
